import { EnvironmentType } from "@/types/types";

export const MAX_NUMBER_OF_CONVERSIONS_HISTORY = 15;
export const MAX_NUMBER_OF_CONVERSION_GROUPS_HISTORY = 7;
export const MAX_NUMBER_OF_ISOLATIONS_HISTORY = 15;
export const MAX_NUMBER_OF_STEM_SPLIT_GROUP_HISTORY = 15;

// Max and min audio upload length
export const MINUTES_MAX_UPLOAD_CONVERSION = 7;
export const MINUTES_MAX_UPLOAD_ISOLATION = 30;
export const MINUTES_MAX_UPLOAD_STEM_SPLIT_GROUP = 7;
export const MINUTES_MIN_UPLOAD_MODEL = 1;
export const MINUTES_MAX_UPLOAD_MODEL = 30;
export const MINUTES_MAX_UPLOAD_MODEL_API_CLIENT = 30;
export const MINUTES_MAX_UPLOAD_CONVERSION_GROUP = 1.25;
export const SECONDS_MAX_EDIT_IN_PITCH_EDITOR = 75;

// Expirations
export const HOURS_UNTIL_UPLOAD_URL_EXPIRES = 18;
export const MINUTES_MARGIN_TO_EXPIRATION_PRESIGNED = 180;
export const DAYS_UNTIL_PRESIGNED_URL_GET_EXPIRES = 7;

// Interval between checks updates
export const SECONDS_CHECK_IF_CONVERSION_UPDATE = 1.5;
export const SECONDS_CHECK_IF_ISOLATION_UPDATE = 1.5;
export const SECONDS_CHECK_IF_MODEL_TRAINING_UPDATE = 15;
export const SECONDS_CHECK_IF_MIXED_MODEL_TRAINING_UPDATE = 1.5;
export const SECONDS_CHECK_IF_CONVERSION_GROUP_UPDATE = 1.5;
export const SECONDS_CHECK_IF_STEM_SPLIT_GROUP_UPDATE = 1.5;

// Timeouts
export const MINUTES_AI_BACKEND_TIMEOUT_CONVERSIONS = 16;
export const MINUTES_AI_BACKEND_TIMEOUT_ISOLATIONS = 20;
export const MINUTES_AI_BACKEND_TIMEOUT_STEM_SPLIT_GROUPS = 20;
export const HOURS_AI_BACKEND_TIMEOUT_MODELS = 16;
export const MINUTES_AI_BACKEND_NOTIFY_AT_0 = 20;
export const MINUTES_AI_BACKEND_TIMEOUT_MIXED_MODELS = 10;

// Urls to various parts of the infrastructure
export const FRONTEND_URL = process.env.NEXT_PUBLIC_BASE_URL as string;

export const AI_BACKEND_URL_SUGGESTED_KEY = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_SUGGESTED_KEY as string;
export const AI_BACKEND_URL_GET_SESSION_SLUG = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_GET_SESSION_SLUG as string;
export const AI_BACKEND_URL_GET_SESSION_SLUG_FOR_FREE = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_GET_SESSION_SLUG_FOR_FREE as string;
export const AI_BACKEND_URL_REDEEM_SESSION_SLUG = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_REDEEM_SESSION_SLUG as string;
export const AI_BACKEND_URL_PITCH_FOR_FREE = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_REDEEM_SESSION_SLUG_FOR_FREE as string;
export const AI_BACKEND_URL_REDEEM_SESSION_SLUG_FOR_FREE = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_PITCH_FOR_FREE as string;
export const AI_BACKEND_URL_PITCH = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_PITCH as string;
export const AI_BACKEND_URL_DOWNLOAD_HARMONY_MAKER_FILES = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_DOWNLOAD_HARMONY_MAKER_FILES as string;

export const AI_BACKEND_URL_CONVERSION = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_CONVERSION as string;
export const AI_BACKEND_URL_ISOLATION = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_ISOLATION as string;
export const AI_BACKEND_URL_MODEL = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_MODEL as string;
export const AI_BACKEND_URL_MIXED_MODEL = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_MIXED_MODEL as string;
export const AI_BACKEND_URL_CHECK_HEALTH = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_CHECK_HEALTH as string;
export const AI_BACKEND_URL_AUDIO_QUALITY_CHECK = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_AUDIO_QUALITY_CHECK as string;

export const NEON_DATABASE_URL = process.env.NEON_DATABASE_URL as string;

export const AI_BACKEND_URL_CONVERSION_ISOLATION_MIXED_MODEL_NEW_VARIANT =
  process.env
    .NEXT_PUBLIC_AI_BACKEND_URL_CONVERSION_ISOLATION_MIXED_MODEL_NEW_VARIANT as string;
export const AI_BACKEND_URL_MODEL_HANS = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_MODEL_HANS as string;

export const AI_BACKEND_URL_CONVERSION_ISOLATION_MIXED_MODEL_SIMPLY = process
  .env
  .NEXT_PUBLIC_AI_BACKEND_URL_CONVERSION_ISOLATION_MIXED_MODEL_SIMPLY as string;

export const AI_BACKEND_URL_MODEL_SCOTT = process.env
  .NEXT_PUBLIC_AI_BACKEND_URL_MODEL_SCOTT as string;

// Cloudflare r2
export const R2_SAMPLES_BUCKET_NAME = process.env
  .R2_SAMPLES_BUCKET_NAME as string;
export const R2_MODELS_BUCKET_NAME = process.env
  .R2_MODELS_BUCKET_NAME as string;
export const R2_MIXED_MODELS_BUCKET_NAME = process.env
  .R2_MIXED_MODELS_BUCKET_NAME as string;
export const R2_SOUNDS_BUCKET_NAME = process.env
  .R2_SOUNDS_BUCKET_NAME as string;
// TTV project media (backing-track audio + saved-render pitch JSON), tracked by ttv_project columns. Deliberately NOT the sounds bucket: that bucket's contract is "every object has a sounds-table row" (the remove-sounds cron manages lifecycle from the table), which column-tracked objects would break.
export const R2_TTV_BUCKET_NAME = process.env.R2_TTV_BUCKET_NAME as string;

export const R2_SECRET_ACCESS_KEY = process.env.R2_SECRET_ACCESS_KEY as string;
export const R2_ACCESS_KEY_ID = process.env.R2_ACCESS_KEY_ID as string;
export const R2_ENDPOINT = process.env.R2_ENDPOINT as string;

// Auth
export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID as string;
export const GOOGLE_SECRET = process.env.GOOGLE_SECRET as string;
export const NEXTAUTH_SECRET = process.env.NEXTAUTH_SECRET as string;
export const NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY = process.env
  .NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY as string;
export const CLERK_SECRET_KEY = process.env.CLERK_SECRET_KEY as string;
export const CLERK_WEBHOOK_SIGNING_SECRET = process.env
  .CLERK_WEBHOOK_SIGNING_SECRET as string;

export const DISCORD_APP_EVENTS_URL = process.env
  .DISCORD_APP_EVENTS_URL as string;
export const DISCORD_APP_EVENTS_PAID_URL = process.env
  .DISCORD_APP_EVENTS_PAID_URL as string;
export const DISCORD_APP_EVENTS_VIP_URL = process.env
  .DISCORD_APP_EVENTS_VIP_URL as string;
export const DISCORD_TIME_OUTS_FAIL_URL = process.env
  .DISCORD_TIME_OUTS_FAIL_URL as string;
export const DISCORD_SERVICES_CHECK_WEBHOOK = process.env
  .DISCORD_SERVICES_CHECK_WEBHOOK as string;

export const ENVIRONMENT = process.env.NODE_ENV as EnvironmentType;

export const YOUTUBE_API_KEY = process.env.YOUTUBE_API_KEY as string;
export const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY as string;
// Personal API key (phx_…) for PostHog's query API — POSTHOG_KEY above can only ingest events, not read them.
export const POSTHOG_API_KEY = process.env.POSTHOG_API_KEY as string;
export const POSTHOG_ENV_ID = process.env.POSTHOG_ENV_ID as string;

export const MAX_TRACKS = 5;

// runner
export const RUNNER_DEBOUNCE = 350;

// mailchimp
export const MAILCHIMP_API_KEY = process.env.MAILCHIMP_API_KEY as string;
export const MAILCHIMP_SERVER_PREFIX = process.env
  .MAILCHIMP_SERVER_PREFIX as string;
export const MAILCHIMP_AUDIENCE_ID = process.env
  .MAILCHIMP_AUDIENCE_ID as string;
export const MAILCHIMP_TRANSACTIONAL_API_KEY = process.env
  .MAILCHIMP_TRANSACTIONAL_API_KEY as string;
export const MAILCHIMP_TRANSACTIONAL_FROM_EMAIL = process.env
  .MAILCHIMP_TRANSACTIONAL_FROM_EMAIL as string;
export const MAILCHIMP_TRANSACTIONAL_TO_EMAIL_FOR_SUPPORT = process.env
  .MAILCHIMP_TRANSACTIONAL_TO_EMAIL_FOR_SUPPORT as string;
export const MAILCHIMP_TRANSACTIONAL_TO_EMAIL_FOR_ENTERPRISE = process.env
  .MAILCHIMP_TRANSACTIONAL_TO_EMAIL_FOR_ENTERPRISE as string;

export const SOFT_LIMIT_MODEL_TRAINING_DATA_SIZE_MB = 400;
export const MULTI_FILE_CLEAR_BUTTON_THRESHOLD = 7;

export const MAX_NUMBER_OF_CONVERSION_INPUTS = 5;
export const MAX_NUMBER_OF_MODEL_INPUTS = 250;

// Notion
export const NOTION_FAQ_DATABASE_ID = "140c299d-b876-8001-a905-f89fbee5427b";

// churn
export const CHURN_DISCOUNT_COUPON_ID = process.env
  .CHURN_DISCOUNT_COUPON_ID as string;
export const CHURN_DISCOUNT_TERMS = process.env.CHURN_DISCOUNT_TERMS as string;
export const CHURN_DISCOUNT_MINIMUM_DURATION = 3;
